import logo from './logo.svg';
import './App.css';
import NEETCutoffAnalysisEbook from "./NEETCutoffAnalysisEbook";

function App() {
  return (
    <div className="App">
      <NEETCutoffAnalysisEbook />
    </div>
  );
}

export default App;